// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/dealer-tasks/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/dealer-tasks/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Dealer Tasks" })
  return <Page />
}
